import { BlockProps, IBlockLocation } from '../../content-blocks/type';
import { UploadImageBlockProps } from './type';

interface Props {
  key: string;
  mappingKey: string;
  location: IBlockLocation;
  label: string;
  height: number;
  width: number;
  isUploadImage?: boolean;
  url?: string;
}

export const createUploadImageBlock = (props: Props): UploadImageBlockProps => {
  const { mappingKey } = props;
  const block: UploadImageBlockProps = {
    type: 'upload_image',
    isVisible: false,
    [mappingKey]: '',
    x: 0,
    y: 0,
    ...props,
  };

  return block;
};

export function isUploadImageBlock(
  block: BlockProps,
): block is UploadImageBlockProps {
  return block.type === 'upload_image';
}
